import $ from 'jquery';

export default () => {
    const header = $('.js-site-header');
    const homeHeader = $('.home .js-site-header');
    const trigger = $('.js-site-header-trigger');
    const nav = $('.js-site-nav');
    const subNavTrigger = nav.find('a[href="#"]');
    const siteContent = $('.js-site-content');
    const banner = $('.js-site-header-banner');
    const hero = $('.js-hero');
    const heroVideo = $('.js-hero-video');
    let headerHeight = header.outerHeight() / 16;
    let bannerHeight = banner.outerHeight() / 16;

    const headroom = new Headroom(header[0], {
        offset: header.outerHeight(),
    });
    headroom.init();

    banner.css('marginTop', headerHeight + 'rem');

    document.addEventListener('scroll', function (e) {
        if (window.scrollY > 100) {
            homeHeader.addClass('bg-white');
            homeHeader.removeClass('bg-transparent');
        } else {
            homeHeader.addClass('bg-transparent');
            homeHeader.removeClass('bg-white');
        }
    });

    $(window).on('load', function (e) {
        header.addClass('bg-white');
        header.removeClass('bg-transparent');
        header.addClass('header-starts-solid');
        homeHeader.removeClass('header-starts-solid');
        homeHeader.addClass('bg-transparent');
        homeHeader.removeClass('bg-white');
    });

    $(window).on('resize', function () {
        headerHeight = header.outerHeight() / 16;
        bannerHeight = banner.outerHeight() / 16;

        banner.css('marginTop', headerHeight + 'rem');

        if (hero.hasClass('has-video')) {
            if ($(window).width() >= 900) {
                hero.css(
                    'height',
                    'calc(100vh - ' + bannerHeight + headerHeight + 'rem)'
                );

                const heroHeight = hero.outerHeight();
                const heroWidth = hero.outerWidth();
                const heroRatio = heroHeight / heroWidth;
                const goldenRatio = 9 / 16;

                if (heroRatio < goldenRatio) {
                    heroVideo.css('width', heroWidth);
                } else {
                    heroVideo.css('width', (hero.outerHeight() * 16) / 9);
                }
            } else {
                hero.css('height', 'auto');
            }
        }
    });

    trigger.on('click', function () {
        $(this).add(nav).toggleClass('is-active');
    });

    subNavTrigger.on('click', function () {
        $(this).next().toggleClass('is-open');
        nav.toggleClass('is-sub-open');
    });

    if (hero.hasClass('has-video') && $(window).width() >= 900) {
        hero.css('height', 'calc(100vh - ' + headerHeight + 'rem)');
        heroVideo.css('width', (hero.outerHeight() * 16) / 9);
    }

    $(window).on('load', function () {
        hero.addClass('is-loaded');
    });

    // Select all links with hashes
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (e) {
            e.preventDefault();
            // On-page links
            if (
                location.pathname.replace(/^\//, '') ==
                    this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length
                    ? target
                    : $('[name=' + target.slice(1) + ']');

                if (target.length) {
                    let offset = header.outerHeight();

                    if (
                        $(window).scrollTop() === 0 ||
                        target.hasClass('Newsletter__form--offset')
                    ) {
                        offset += 200;
                    }

                    $('html, body').animate(
                        {
                            scrollTop: target.offset().top - offset,
                        },
                        1000,
                        function () {
                            // focus on form
                            if (target.hasClass('Newsletter__form')) {
                                target.find('input').first().focus();
                            }
                        }
                    );
                }
            }
        });
};



// WEBPACK FOOTER //
// ../src/scripts/modules/header.js